import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface UserRow {
  id: string;
  email: string;
  name: string | null;
  role: "admin" | "user" | "trial";
  createdAt: number;
}

export function UsersPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "users"],
    queryFn: () => api.get<{ users: UserRow[] }>("/api/admin/users"),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Users</h1>
      <div className="pfh-card overflow-x-auto">
        {isLoading ? (
          <div className="text-muted-foreground">loading…</div>
        ) : (data?.users?.length ?? 0) === 0 ? (
          <div className="text-muted-foreground">
            no users yet — CF Access auto-provisions one on first sign-in.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="pfh-heading text-left">
                <th className="py-2">ID</th>
                <th>Email</th>
                <th>Name</th>
                <th>Role</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody className="font-mono">
              {data!.users.map((u) => (
                <tr key={u.id} className="border-t border-border/60">
                  <td className="py-2">{u.id}</td>
                  <td className="font-sans">{u.email}</td>
                  <td className="font-sans">{u.name ?? "—"}</td>
                  <td>{u.role}</td>
                  <td className="text-muted-foreground">
                    {new Date(u.createdAt).toISOString().slice(0, 10)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <p className="text-xs text-muted-foreground">
        Users are managed by Better Auth + CF Access. Role changes require a
        SQL update on the `users` table for v1 until the /api/admin/users
        PATCH endpoint lands.
      </p>
    </div>
  );
}
